export default (props) => {
    var width = props.width;
    if(!width) width = "3em"
    return (<svg version="1.0" 
 width={width} height={width} viewBox="-0 -512 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">
<title>DaySign.ru</title>
<g transform="scale(0.100000,-0.100000)">
<path fill="#000000" stroke="none" d="M1665 5068 c-27 -4 -102 -14 -165 -23 -133 -17 -248 -53 -395 -124
-320 -152 -590 -416 -778 -761 -108 -196 -218 -525 -238 -711 -17 -149 -24
-1553 -9 -1679 56 -470 199 -820 468 -1142 254 -304 644 -527 995 -570 133
-16 1695 -23 1902 -8 238 17 381 54 591 154 134 64 232 130 340 228 276 249
473 559 581 913 29 95 63 271 75 395 19 180 18 1526 0 1665 -34 251 -94 457
-197 670 -226 468 -588 791 -1055 940 -164 52 -277 58 -1215 59 -467 1 -872
-2 -900 -6z m1685 -79 c357 -23 571 -89 825 -257 140 -93 346 -299 444 -446
170 -256 275 -531 328 -856 16 -104 18 -184 18 -850 0 -784 -2 -830 -51 -1055
-153 -702 -640 -1236 -1244 -1365 -199 -43 -251 -45 -1085 -44 -832 0 -923 4
-1123 45 -277 56 -505 179 -726 389 -294 281 -477 643 -558 1105 -23 127 -23
145 -23 875 0 795 2 835 51 1057 51 231 142 455 262 646 80 128 159 223 281
339 266 253 569 386 951 417 150 11 1465 12 1650 0z"/>
<path fill="#000000" stroke="none" d="M1885 4679 c-410 -16 -688 -133 -961 -404 -234 -232 -389 -537 -461
-905 l-27 -135 -4 -650 c-2 -437 0 -686 8 -760 72 -706 516 -1275 1105 -1418
62 -15 100 -22 222 -37 39 -5 401 -10 805 -11 633 -1 748 1 843 16 188 28 285
57 419 124 381 192 665 557 790 1016 61 226 61 224 61 1010 0 786 0 786 -62
1009 -152 553 -546 972 -1028 1095 -172 44 -285 50 -940 53 -341 2 -687 0
-770 -3z m1437 -80 c335 -34 590 -150 816 -372 97 -95 202 -229 202 -258 0
-36 -52 -123 -104 -174 -77 -74 -136 -102 -268 -125 -153 -27 -222 -54 -281
-109 -65 -60 -95 -123 -113 -233 -28 -177 -70 -216 -261 -244 -311 -44 -400
-131 -417 -408 -4 -55 -12 -106 -18 -113 -15 -19 -621 -19 -636 0 -6 7 -14 58
-18 113 -8 122 -23 187 -58 242 -52 82 -148 131 -309 157 -189 31 -199 34
-244 80 -34 36 -44 56 -57 114 -9 38 -16 83 -16 99 0 47 -56 147 -111 196 -62
56 -123 79 -264 101 -122 19 -191 48 -264 111 -55 47 -121 148 -121 184 0 68
234 319 400 428 171 113 394 190 606 210 142 13 1410 14 1536 1z m-2558 -774
c11 -19 47 -62 82 -95 83 -79 165 -118 292 -136 53 -8 118 -21 144 -30 110
-36 170 -115 189 -250 13 -97 38 -157 87 -207 52 -54 105 -78 192 -88 110 -12
244 -47 287 -76 82 -53 107 -125 117 -333 12 -248 -14 -429 -72 -493 -40 -45
-177 -90 -320 -107 -172 -19 -265 -114 -287 -294 -21 -180 -99 -247 -325 -284
-174 -29 -291 -99 -371 -223 -18 -27 -40 -49 -49 -49 -36 0 -144 283 -180 467
-35 184 -42 355 -37 998 4 623 6 658 46 840 28 123 113 343 153 392 14 17 31
7 52 -32z m3684 -37 c77 -161 130 -361 152 -577 13 -136 13 -1222 -1 -1371
-13 -144 -51 -335 -85 -432 -38 -107 -104 -246 -120 -252 -8 -3 -27 15 -50 49
-83 126 -195 194 -370 225 -136 24 -185 41 -234 80 -51 41 -78 100 -96 211 -8
50 -23 108 -34 128 -45 88 -156 161 -248 161 -57 1 -207 37 -259 62 -113 57
-137 133 -136 443 0 372 34 431 278 485 50 11 110 20 135 20 91 1 198 76 239
170 11 25 24 78 29 117 14 99 50 174 102 212 52 38 109 56 235 76 62 10 124
27 163 45 71 33 171 123 209 188 14 23 31 42 38 42 7 0 31 -37 53 -82z m-1570
-1335 c5 -10 13 -65 17 -122 4 -57 13 -125 21 -151 41 -138 165 -215 387 -240
63 -8 110 -20 147 -38 47 -23 59 -35 82 -82 17 -34 31 -84 36 -130 25 -202
152 -305 415 -335 124 -14 263 -113 322 -230 27 -54 27 -58 12 -88 -24 -50
-140 -189 -214 -257 -145 -133 -337 -243 -517 -295 -190 -54 -232 -56 -1076
-52 -762 3 -777 4 -875 26 -207 47 -373 124 -530 247 -125 97 -290 280 -310
344 -11 34 39 121 105 184 74 70 159 111 265 126 251 36 359 128 386 327 6 46
21 100 37 133 37 76 78 97 237 121 185 28 276 68 335 151 40 54 57 120 66 243
3 55 11 108 16 118 8 16 34 17 318 17 284 0 310 -1 318 -17z"/>
<path fill="#0090ff" stroke="none" d="M667 3763 c-83 -178 -128 -365 -147 -607 -13 -168 -13 -1060 1 -1245
13 -191 42 -351 84 -479 45 -133 110 -272 127 -271 7 0 30 27 52 60 69 108
196 188 329 209 171 27 244 54 292 112 39 46 52 81 69 187 28 177 119 268 286
286 66 7 194 35 241 53 39 16 88 61 109 102 33 64 43 168 37 390 -5 224 -16
283 -64 340 -47 57 -148 93 -312 111 -185 21 -274 105 -302 290 -20 134 -68
209 -158 248 -26 11 -100 29 -165 40 -181 30 -298 99 -377 222 -18 27 -38 49
-44 49 -7 0 -32 -44 -58 -97z"/>
<path fill="#ffff00" stroke="none" d="M4345 3805 c-90 -126 -194 -187 -370 -215 -139 -22 -204 -50 -254
-107 -39 -44 -54 -87 -80 -227 -18 -97 -86 -184 -175 -221 -18 -8 -64 -17
-102 -21 -81 -7 -215 -39 -258 -61 -116 -58 -141 -149 -133 -492 5 -239 14
-283 68 -338 52 -54 173 -96 314 -109 170 -16 259 -103 290 -284 22 -125 39
-163 92 -210 52 -45 108 -66 230 -85 48 -7 114 -23 146 -35 82 -31 174 -105
222 -178 22 -33 46 -61 52 -61 32 -2 128 236 167 410 48 217 51 280 51 959 0
660 -3 724 -45 920 -29 133 -129 396 -158 414 -6 3 -31 -23 -57 -59z"/>
<path fill="#ff0000" stroke="none" d="M2250 2455 c-6 -8 -16 -63 -21 -122 -14 -161 -29 -205 -97 -273 -67
-67 -127 -93 -265 -115 -175 -28 -197 -35 -237 -72 -43 -38 -65 -94 -75 -188
-9 -82 -54 -174 -111 -224 -58 -51 -130 -78 -269 -102 -67 -12 -131 -30 -165
-47 -65 -32 -159 -121 -189 -180 -34 -67 -29 -88 45 -181 242 -307 530 -465
924 -511 64 -8 337 -10 830 -8 817 4 807 4 1019 75 127 42 218 88 325 164 151
108 356 334 356 393 0 70 -109 199 -211 248 -35 18 -99 35 -174 48 -66 11
-142 31 -171 44 -115 53 -177 141 -200 288 -29 176 -79 225 -249 242 -93 9
-210 41 -262 72 -109 63 -147 140 -162 319 -5 64 -14 122 -21 130 -18 22 -602
22 -620 0z"/>
<path fill="#ffffff" stroke="none" d="M1915 4599 c-204 -7 -290 -20 -440 -70 -186 -62 -343 -159 -490 -304
-97 -95 -192 -213 -201 -251 -8 -32 41 -119 100 -177 67 -66 161 -111 266
-127 266 -40 367 -128 400 -349 18 -125 53 -180 135 -211 15 -6 76 -17 136
-26 120 -16 197 -40 255 -77 100 -63 132 -130 148 -306 6 -69 15 -132 19 -138
10 -16 603 -18 627 -4 10 7 17 47 26 138 14 158 36 215 106 278 27 24 75 54
106 65 53 20 94 29 271 59 125 20 169 75 195 240 18 112 58 186 131 242 57 44
116 64 256 89 65 11 128 29 160 45 72 37 163 126 195 192 32 65 30 71 -60 187
-189 243 -450 406 -761 478 -82 19 -127 22 -505 25 -228 2 -521 4 -650 6 -129
1 -320 -1 -425 -4z"/>
<path fill="#ffffff" stroke="none" d="M1725 4988 c-219 -16 -450 -75 -615 -158 -84 -43 -227 -140 -312
-214 -286 -245 -508 -636 -592 -1041 -42 -206 -46 -276 -46 -1035 -1 -613 2
-743 15 -840 89 -636 442 -1168 943 -1419 162 -81 346 -130 567 -150 71 -6
440 -11 905 -12 695 -2 799 0 909 15 186 26 278 49 417 107 275 114 519 322
705 598 151 224 246 460 306 761 l27 135 4 777 c3 835 1 882 -50 1103 -86 374
-291 735 -550 969 -264 239 -542 360 -911 397 -128 12 -1560 18 -1722 7z
m1680 -322 c333 -44 569 -161 804 -396 187 -188 342 -460 415 -730 72 -266 80
-407 67 -1180 -10 -631 -11 -642 -66 -847 -143 -539 -527 -961 -997 -1097
-200 -58 -235 -60 -1053 -59 -698 1 -759 2 -885 21 -326 49 -563 172 -795 414
-241 250 -394 579 -450 964 -14 96 -16 206 -12 810 4 654 5 705 24 799 78 385
223 666 467 911 67 66 155 144 197 172 208 139 423 211 692 231 56 4 413 6
792 5 542 -2 714 -6 800 -18z"/>
</g>
</svg>)
}